import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { AppState } from 'src/app/core/app.state';
import { ICompaniesGroups } from 'src/app/features/companies-groups/models/companies-groups.model';
import { ILocation } from 'src/app/features/customers/models/customers.models';
import { FetchAllLocations } from 'src/app/features/customers/store/customers.actions';
import { selectCanDo } from 'src/app/core/store/permissions/permissions.selectors';
import { HasPermissionContext } from 'src/app/shared/has-permission.directive';
import { parseLocationToItemData } from 'src/app/shared/utils/helpers';
export interface ItemData {
  id?: number;
  label: string;
  company_name?: string;
  add_discount?: number;
  whole_discount?: number;
  description?: string;
  locations?: ILocation[];
  type: string;
}
@Component({
  selector: 'app-inserting-locations',
  templateUrl: './inserting-locations.component.html',
  styleUrls: ['./inserting-locations.component.scss']
})
export class InsertingLocationsComponent implements OnInit {
  @Input() selectedLocationsO: ILocation[] = [];
  @Input() currentCustomDiscount!: number;
  @Input() submitType: string = '';
  selectedLocations: ILocation[] = [];
  selectedData: ItemData[] = [];
  @Output() saveLocations = new EventEmitter<ILocation[]>();
  @Output() cancelLocations = new EventEmitter<string>();
  expandedIndex: number = -1;
  expandedSeletedIndex: number = -1;
  locations$: Observable<ILocation[]> = this.store.select((state) => state.customers.allLocations);
  groupes$: Observable<ICompaniesGroups[]> = this.store.select((state) => state.companiesGroups.AllCompaniesGroups);
  private subscriptions: Subscription[] = [];
  locations: ILocation[] = [];
  allLocations: ILocation[] = [];
  data: ItemData[] = [];
  allData: ItemData[] = [];
  search = new FormControl()
  canSubmit = false;
  constructor(
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this.store.dispatch(FetchAllLocations())
    this.selectedLocations = [...this.selectedLocationsO]
    const sub1 = this.locations$.subscribe(locations => {
      this.allLocations = locations;
      this.allLocations.map((location: ILocation) => {
        if (!this.allData.find(item => (item.id === location.id_company && item.type === 'company')))
          this.allData.push({
            id: location.id_company,
            label: location.company_name!,
            locations: this.allLocations.filter(l => l.id_company === location.id_company),
            type: 'company'
          })
      });
      this.filterLocations()
    });

    const sub2 = this.groupes$.subscribe(groupes => {
      groupes.map((groupe: ICompaniesGroups) => {
        if (!this.allData.find(item => item.id === groupe.id && item.type === 'group'))
          this.allData.push({
            id: groupe.id,
            label: groupe.name,
            locations: groupe.locations,
            type: 'group'
          })
      });
      this.filterLocations()
    });

    this.selectedLocations.map((location: ILocation) => {
      this.selectedData.push({
        id: location.id,
        label: location.name,
        company_name: location.company_name,
        add_discount: location.custom_discount,
        description:
          location.apartment ? location.apartment + '. ' : '',
        type: 'location'
      })
    })

    const sub3 = this.search.valueChanges.pipe(
        startWith(''),
        map(searchTerm => searchTerm.toLowerCase())
      ).subscribe(searchTerm => {
        this.filterLocations(searchTerm);
      })

    const action = this.submitType === 'stepper' ? 'create' : 'edit';
    const sub4 = this.store.select(selectCanDo('catalog', action)).subscribe((canSubmit) => {
      this.canSubmit = canSubmit;
    });

    this.subscriptions.push(sub1, sub2, sub3, sub4);
  }

  sortData(): void {
    this.data.sort((a, b) => a.label.localeCompare(b.label));
  }

  filterLocations(searchTerm: string = ''): void {
    this.data = [];
    const selectedIds = this.selectedData.map((l) => l.id);
    this.allData.forEach((item) => {
      if (this.itemRespectsSearchTerm(item, searchTerm)) {
        if (
          item.type === 'location' &&
          !selectedIds.includes(item.id as number)
        )
          this.data.push(item);
        else if (item.locations && item.locations.length > 0) {
          const itemSearchLocations = item.locations.filter(
            (l) => !selectedIds.includes(l.id) && l.name.toLowerCase().includes(searchTerm.toLowerCase().trim())
          )
          const itemLocations = item.locations.filter(
            (l) => !selectedIds.includes(l.id)
          )
          if(itemSearchLocations.length > 0 && !item.label.toLowerCase().includes(searchTerm.toLowerCase().trim()))
            this.data.push({
              ...item,
              locations: itemSearchLocations
            });
          if(itemLocations.length > 0 && item.label.toLowerCase().includes(searchTerm.toLowerCase().trim()))
            this.data.push({
              ...item,
              locations: itemLocations
            });
        }
      }
    });
    this.sortData();
  }

  itemRespectsSearchTerm(item: ItemData, searchTerm: string = ''): boolean {
    searchTerm = searchTerm.toLowerCase().trim();
    if (item.label.toLowerCase().includes(searchTerm)) return true;
    if (!item.locations || item.locations.length === 0) return false;
    return item.locations.filter((l: ILocation) =>
          l.name.toLowerCase().includes(searchTerm)
      ).length > 0;
  }

  addItem(item: ItemData, index: number) {
    if (!this.canSubmit) return;
    if (item.locations) {
      this.selectedData.push(...item.locations.map(parseLocationToItemData));
    } else {
      this.selectedData.push(item);
    }
    this.filterLocations(this.search.value || '');
  }


  addLocation(location: ILocation, index: number) {
    if (!this.canSubmit) return;
    this.selectedData.push({
      company_name: location.company_name,
      ...parseLocationToItemData(location)
    }
  );
  this.filterLocations(this.search.value ? this.search.value : '')
  }

  removeLocation(item: ItemData, index: number) {
    if (!this.canSubmit) return;
    this.selectedData.splice(index, 1);
    this.filterLocations(this.search.value ? this.search.value : '')
  }

  drop(event: CdkDragDrop<ItemData[]>) {
    if (!this.canSubmit) return;
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.selectedData.forEach((item: ItemData, index) => {
      if(item.locations && item.locations.length > 0){
        this.selectedData.splice(index, 1);
        this.selectedData.push(...item.locations?.map(l => ({
            id: l.id,
            label: l.name,
            add_discount: l.custom_discount,
            description:
              l.apartment ? l.apartment + '. ' : '',
            type: 'location'
          })))
      }
    })
    this.filterLocations(this.search.value ? this.search.value : '')
  }


  trackByFn(index: number, item: ItemData) {
    return item.id;
  }

  toggleGroupe(id: number) {
    this.expandedIndex = this.expandedIndex === id ? -1 : id;
  }

  toggleSelectedGroupe(id: number) {
    this.expandedSeletedIndex = this.expandedSeletedIndex === id ? -1 : id;
  }

  save(): boolean | void {
    if (!this.canSubmit) return;
    this.selectedLocationsO = [];
    this.selectedData.forEach(item => {
      if (item.locations) {
        item.locations.forEach(location => {
          if (!this.selectedLocationsO.find(loc => loc.id === location.id)) this.selectedLocationsO.push(location)
        });
      }
      else {
        const loc = this.allLocations.find(location => location.id === item.id);
        if (loc && !this.selectedLocationsO.find(loc => loc.id === item.id)) this.selectedLocationsO.push(loc)
      }
    })
    this.saveLocations.emit(this.selectedLocationsO);
    this.data = []
  }

  cancel() {
    const submitType = this.submitType === 'stepper' ? 'stepper' : 'summary';
    this.cancelLocations.emit(submitType);
    this.data = []
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }

  submitPermission(): HasPermissionContext {
    return { module: 'catalog', action: this.submitType === 'stepper' ? 'create' : 'edit' };
  }
}
